import { render } from "./ManageCategory.vue?vue&type=template&id=8effb8e8&scoped=true"
import script from "./ManageCategory.vue?vue&type=script&lang=js"
export * from "./ManageCategory.vue?vue&type=script&lang=js"

import "./ManageCategory.vue?vue&type=style&index=0&id=8effb8e8&scoped=true&lang=css"

import exportComponent from "/var/www/admin_web_aaac/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8effb8e8"]])

export default __exports__